import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {FontName} from '@mintdata/mint-kit/api/models/FontItem';
import {FontVariant} from '@mintdata/mint-kit/api/models/FontWeight';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 62;

const fontPaths = [
    'font',
    'hoverState.font',
    'activeState.font',
    'focusState.font',

    // Dropdown
    'placeholder.font',
    'pill.font',

    // Tabs
    'normalState.tabAppearance.font',
    'hoverState.tabAppearance.font',
    'activeState.tabAppearance.font',
    'selectedState.tabAppearance.font',

    // TextInput
    'tooltipSettings.font', // + TooltipDecorator
    'prefixSuffixFont',

    // Chart
    'title.font',
    'legend.font',
    'axes.xAxis.title.font',
    'axes.xAxis.ticks.font',
    'axes.yAxis.title.font',
    'axes.yAxis.ticks.font',

    // Table
    'style.header.font',
    'style.cell.font',
];

const usedFonts = new Set();

export const migration_61_62:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        const loaderModel = getModel('loader', componentDesc._baseProperties);

                        if( loaderModel )
                            migrateFont(loaderModel, 'caption.font');

                        let model = getModel('model', componentDesc._properties);
                        if( !model )
                            model = getModel('chart', componentDesc._properties);

                        model && fontPaths.forEach((fontPath:string) => migrateFont(model, fontPath));

                    });
                }
            });
        }

        if( designState.assets && designState.assets.fontsState )
        {
            const {fontsState} = designState.assets;

            fontsState.usedFonts = Array.from(usedFonts.keys());
            fontsState.recentFonts = [];
            fontsState.favoriteFonts = [];
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function getModel(propName, props)
{
    return props && props[propName] && props[propName]._value;
}

const weights = {
    Thin: FontVariant.THIN,
    Light: FontVariant.LIGHT,
    Regular: FontVariant.REGULAR,
    Medium: FontVariant.MEDIUM,
    Bold: FontVariant.BOLD, // HELVETICA_NEUE -> 600 -> FontVariant.SEMI_BOLD
};

function migrateFont(model, fontPath)
{
    const font = getValueByPath(model, fontPath);

    if( !font ) return;

    const fontName:FontName = font.typeface && font.typeface.selectedValue;

    if( fontName )
    {
        font.typeface = {
            __type: 'STRING',
            value: fontName,
        };

        usedFonts.add(fontName);
    }

    const fw = font.weight && font.weight.selectedValue;

    if( fw )
    {
        const isItalic = font.fontStyle ? font.fontStyle.value : false;
        let value = weights[fw] ? weights[fw] : FontVariant.REGULAR;

        if( isItalic )
        {
            if( value === FontVariant.REGULAR )
                value = FontVariant.ITALIC;
            else
                value += FontVariant.ITALIC;
        }

        font.weight = {
            __type: 'STRING',
            value,
        };
    }

    delete font.fontStyle;
}

function getValueByPath(obj, path)
{
    const parts = path.split('.');
    let rv;
    let index;

    for( rv = obj, index = 0; rv && index < parts.length; ++index )
    {
        rv = rv[parts[index]];
    }
    return rv;
}
